import type { Content } from '../../interface/Content';
import type { Paginated } from '@/interface/Paginate';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';
import { authKeys } from '@/config/keys';
import { getCookie } from '@/utils/cookies';

const getTopContent = async () => {
  const params = {
    page: 1,
    limit: 10,
  };

  const authToken = getCookie(authKeys.authToken);
  const urlFetchTopContent = authToken
    ? apiConfig.routes.research.topContents
    : apiConfig.routes.research.topContentsPublic;

  const { data } = await api.get<Paginated<TopContent>>(urlFetchTopContent, {
    params,
  });

  return data.data;
};

export const useGetTopContent = () =>
  useQuery({
    queryKey: ['top-content', 'research'],
    queryFn: getTopContent,
  });

export type TopContent = Omit<Content, 'watch'>;
